import React from 'react'
import classes from 'classnames'

import styles from './Toast.module.scss'

interface ToastPropsType {
  active: boolean,
  onClick: (e: object) => void,
  text: string
}

const Toast = (props: ToastPropsType) => {
  const {
    active = false,
    onClick = () => {},
    text = ''
  } = props

  const toastClasses = classes(styles[`toast`], {
    [styles[`toastActive`]]: active
  })
  return (
    <button
      className={toastClasses} 
      onClick={onClick}>{text}</button>
  )
}

export default Toast;
